export function addFSToken(baseUrl: string, fsToken: string): string {
  try {
    const url = new URL(baseUrl);
    url.searchParams.set('token', fsToken);
    return url.toString();
  } catch (_error) {
    console.log(`Failed to parse "${baseUrl}" to URL object`);
    return baseUrl;
  }
}

export function doesExceedFileSizeLimit(
  fileContent: string,
  limit: number
): boolean {
  const blob = new Blob([fileContent]);
  return blob.size >= limit;
}
